const Dots = (props) => {
  return (
    <>
      <div className="bouncing-loader" data-testid="dots-loader">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </>
  )
}

export default Dots
